import React, { useState } from "react";
import logo from "../assets/img/logo.svg";
import prev_arrow from "../assets/img/prev_arrow.svg";
import next_arrow from "../assets/img/next_arrow.svg";

const Step72 = ({ setStep, setFormdata, formData }) => {
  const [phoneError, setPhoneError] = useState(""); // State to hold error message

  // Phone number validation function (can be customized to your needs)
  const validatePhoneNumber = (phoneNumber) => {
    const regex = /^[0-9]{10}$/; // Simple regex to check for 10 digits
    return regex.test(phoneNumber);
  };

  const Next = () => {
    if (!formData?.phoneNumber || !validatePhoneNumber(formData?.phoneNumber)) {
      // Set error message if phone number is invalid
      setPhoneError("Please enter a valid 10-digit phone number.");
    } else {
      // Clear error message and proceed to the next step
      setPhoneError("");
      setStep(8);
    }
  };

  return (
    <>
      {/* <section class="step_wrapper"> */}
        <div class="top_logo_block">
          <div class="logo">
            <a href="">
              <img src={logo} alt="" />
            </a>
          </div>
        </div>

        <div class="step_body">
          <div class="step_form">
            <div class="form_block box_width_md_one">
              <h1>What is your phone number?</h1>
              <div class="input_fields">
                <input
                  type="text"
                  placeholder="Enter your valid phone number"
                  value={formData?.phoneNumber}
                  onChange={(e) =>
                    setFormdata((prevState) => ({
                      ...prevState, // Keep all other fields the same
                      phoneNumber: e.target.value, // Update the name field
                    }))
                  }
                />
              {phoneError && <p className="error_txt" style={{color:"red"}}>{phoneError}</p>} {/* Display error message */}

              </div>
            </div>
            <div class="btn_block">
              <a onClick={() => setStep(7)}>
                {" "}
                <img src={prev_arrow} alt="" /> <span>Prev</span>{" "}
              </a>
              <a onClick={() => Next()} class="nxt_btn">
                {" "}
                <span>next</span> <img src={next_arrow} alt="" />
              </a>
            </div>
          </div>
        </div>

        {/* <div class="bottom_steps">
          <ul class="for_desktop">
            <li class="step_done">
              <span>Referrals</span>
            </li>
            <li class="step_done">
              <span>Your details</span>
            </li>
            <li class="step_done">
              <span>Profession</span>
            </li>
            <li class="step_done">
              <span>Ideal Client</span>
            </li>
            <li class="step_done">
              <span>Good referral partners</span>
            </li>
            <li class="step_done">
              <span>Date of birth</span>
            </li>
            <li class="active">
              <span>Communication channel</span>
            </li>
            <li>
              <span>Hobbies</span>
            </li>
            <li>
              <span>Submit</span>
            </li>
          </ul>
          <div class="step_for_mob">
            <p>
              <span>7</span> of 9
            </p>
          </div>
        </div>
      </section> */}
    </>
  );
};

export default Step72;
